import { Component, Input, OnInit, NgModule, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import {Hit} from "../../../../../services/model/hit";
import {SubscriptionLike as ISubscription} from "rxjs/internal/types";
import {StringToStringMap} from "../../../../interfaces/string-string-map.interface";
import {CacheService} from "../../../../../services/sys/cache.service";
import {QueryManagerService} from "../../../../../services/domain/query-manager.service";
import {QueryCategory} from "../../../../../services/model/queryCategory";
import {StaticsService} from "../../../../../services/sys/statics.service";
import {Observable, Subscription} from "rxjs";



@Component({
    selector: 'efast-breadcrumb',
    templateUrl: 'efast-breadcrumb.component.html',
    styleUrls: ['efast-breadcrumb.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class EfastBreadcrumbComponent implements OnInit {

    queryCategories: QueryCategory[];
    @Input() events: Observable<void>;

    isBreadcrumbShown: boolean = false;
    categoryLabels: StringToStringMap<string> = {};
    private eventsSubscription: Subscription;

    constructor(private queryManagerService: QueryManagerService,
                private cacheService: CacheService,
                private staticsService: StaticsService) {
    }

    public deleteQueryValue(value:string, categoryType:string) {
         this.queryManagerService.deleteQueryValue(value, categoryType);
    }

    public deleteQueryCategory(categoryType:string) {
        this.queryManagerService.deleteQueryCategory(categoryType);
    }

    ngOnInit() {
        this.queryCategories = this.queryManagerService.getQueryCategories();
        this.categoryLabels['planName'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONBreadcrumbPlanNameLbl');
        this.categoryLabels['ein'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONBreadcrumbEINLbl');
        this.categoryLabels['pn'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONBreadcrumbPNLbl');
        this.categoryLabels['planSponsor'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONBreadcrumbPlanSponsorLbl');
        this.categoryLabels['ackid'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONBreadcrumbACKIDLbl');

        this.categoryLabels['planYears'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONBreadcrumbPlanYearsLbl');
        this.categoryLabels['planCodes'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONBreadcrumbPlanCodesLbl');
        this.categoryLabels['assets'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONBreadcrumbAssetsLbl');
        this.categoryLabels['employer'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONBreadcrumbEmployerLbl');
        this.categoryLabels['participants'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONBreadcrumbParticipantsLbl');
        this.categoryLabels['business'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONBreadcrumbBusinessLbl');
        this.categoryLabels['states'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONBreadcrumbStatesLbl');
        this.categoryLabels['countries'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONBreadcrumbCountriesLbl');
        this.categoryLabels['formYear'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONBreadcrumbFormYearsLbl');
        this.categoryLabels['zipcode'] = this.cacheService.getLabelFromResource('INITIALIZATION:INITIALIZATIONBreadcrumbZipcodeLbl');


        this.evalQueryCriteraDisplayValues();
        this.eventsSubscription = this.events.subscribe(() => this.searchChangeEvent());
    }

    private searchChangeEvent() {

        this.queryCategories = this.queryManagerService.getQueryCategories();
        if (this.queryCategories.length > 0) {
            this.isBreadcrumbShown = true;
            this.evalQueryCriteraDisplayValues();
        }
        else {
            this.isBreadcrumbShown = false;
        }

    }
    private evalQueryCriteraDisplayValues() {
        for (let queryCategory of this.queryCategories) {
            if (queryCategory.type == this.staticsService.getCategoryType().PLAN_NAME) {
                queryCategory.displayValue = this.categoryLabels['planName'];
            }
            else if (queryCategory.type == this.staticsService.getCategoryType().PLAN_SPONSOR) {
                queryCategory.displayValue = this.categoryLabels['planSponsor'];
            }
            else if (queryCategory.type == this.staticsService.getCategoryType().EIN) {
                const hyphenRegex = /\-?\d{2}-\d{7}$/
                for (let queryVal of queryCategory.queryValues){
                    //check to see if display value is already modified for EIN hyphen
                    if(!queryVal.displayValue.match(hyphenRegex)){
                        if(queryVal.displayValue.substring(0,1)==='-'){
                        queryVal.displayValue = queryVal.displayValue.substring(0,3) + "-" + queryVal.displayValue.substring(3,10);
                        }
                        else{
                            queryVal.displayValue = queryVal.displayValue.substring(0,2) + "-" + queryVal.displayValue.substring(2,9);
                        }
                    }                    
                }
                queryCategory.displayValue = this.categoryLabels['ein'];
            }
            else if (queryCategory.type == this.staticsService.getCategoryType().PN) {
                queryCategory.displayValue = this.categoryLabels['pn'];
            }
            else if (queryCategory.type == this.staticsService.getCategoryType().ACK_ID) {
                queryCategory.displayValue = this.categoryLabels['ackid'];
            }
            else if (queryCategory.type == this.staticsService.getCategoryType().PLAN_YEAR) {
                queryCategory.displayValue = this.categoryLabels['planYears'];
            }
            else if (queryCategory.type == this.staticsService.getCategoryType().PLAN_CODE) {
                queryCategory.displayValue = this.categoryLabels['planCodes'];
            }
            else if (queryCategory.type == this.staticsService.getCategoryType().ASSETS) {
                queryCategory.displayValue = this.categoryLabels['assets'];
            }
            else if (queryCategory.type == this.staticsService.getCategoryType().PARTICIPANTS) {
                queryCategory.displayValue = this.categoryLabels['participants'];
            }
            else if (queryCategory.type == this.staticsService.getCategoryType().EMPLOYER) {
                queryCategory.displayValue = this.categoryLabels['employer'];
            }
            else if (queryCategory.type == this.staticsService.getCategoryType().BUSINESS) {
                queryCategory.displayValue = this.categoryLabels['business'];
            }
            else if (queryCategory.type == this.staticsService.getCategoryType().STATES) {
                queryCategory.displayValue = this.categoryLabels['states'];
            }
            else if (queryCategory.type == this.staticsService.getCategoryType().COUNTRIES) {
                queryCategory.displayValue = this.categoryLabels['countries'];
            }
            else if (queryCategory.type == this.staticsService.getCategoryType().FORM_YEAR) {
                queryCategory.displayValue = this.categoryLabels['formYear'];
            }
            else if (queryCategory.type == this.staticsService.getCategoryType().ZIPCODE) {
                queryCategory.displayValue = this.categoryLabels['zipcode'];
            }
        }
    }

    ngOnDestroy() {
        this.eventsSubscription.unsubscribe();
    }

    showDelIcon(event) {
        event.target.classList.add('show-delete-icon')
     }
     
    hideDelIcon(event) {
        event.target.classList.remove('show-delete-icon')
    }
}